import {AddSchema} from "mobx-graphlink";
import {AlarmConfigBase, AlarmConfigBase_SchemaProps} from "./@AlarmConfig.js";

export class EngineConfig_CountdownAlarm extends AlarmConfigBase {
	//constructor(data: EngineConfig_CountdownAlarm) { super(data); }
}
AddSchema("EngineConfig_CountdownAlarm", {
	properties: {
		...AlarmConfigBase_SchemaProps as any,
	},
});